import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCol, {
    staticClass: "pt-1 pb-0 my-0 integration",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.modules.disablePromptHeader'),
      "open": _vm.activationPrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('accMgmt.tenant.integrations.activate'),
        color: _vm.color,
        emit: 'activate'
      }]
    },
    on: {
      "cancel": _vm.cancelActivation,
      "activate": function ($event) {
        return _vm.activate(_vm.integrationToActivate);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.activateConfirmation')) + "\n  ")]), !_vm.accountId ? _c('div', _vm._l([0, 1], function (j) {
    return _c(VRow, {
      key: `module_skeleton_${j}`,
      staticClass: "my-0 py-0",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "1"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "button"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0 pl-0"
    }, [_c(VRow, {
      staticClass: "my-0 py-0"
    }, [_c(VCol, {
      attrs: {
        "cols": "5"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    }), _c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1)], 1)], 1)], 1);
  }), 1) : _vm._e(), _vm.accountId ? _c('div', _vm._l(_vm.offeredIntegrations, function (integration) {
    return _c(VRow, {
      key: integration.type,
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      staticClass: "py-0 my-0",
      attrs: {
        "cols": "12"
      }
    }, [_c(VSwitch, {
      attrs: {
        "color": _vm.color,
        "disabled": integration.isEnabled,
        "inset": "",
        "hide-details": ""
      },
      on: {
        "change": function ($event) {
          return _vm.confirmActivation(integration);
        }
      },
      scopedSlots: _vm._u([{
        key: "label",
        fn: function () {
          return [_c('h4', {
            style: `opacity: ${integration.id ? 1.0 : 0.45}`
          }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t(`accMgmt.tenant.integrations.${integration.type}.header`)) + "\n              " + _vm._s(integration.isEnabled ? '(' + _vm.$i18n_t(`accMgmt.tenant.integrations.isActive`) + ')' : '') + "\n            ")])];
        },
        proxy: true
      }], null, true),
      model: {
        value: integration.isEnabled,
        callback: function ($$v) {
          _vm.$set(integration, "isEnabled", $$v);
        },
        expression: "integration.isEnabled"
      }
    }), _c('div', {
      style: `opacity: ${integration.id ? 1.0 : 0.65}`
    }, [_c('p', {
      staticClass: "my-0"
    }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t(`accMgmt.tenant.integrations.${integration.type}.description`)) + "\n          ")]), integration.type == 'iec104' || integration.type == 'iec104_push' ? _c('p', {
      staticClass: "my-0",
      staticStyle: {
        "font-weight": "500"
      }
    }, [_vm._v("\n            INFO: " + _vm._s(_vm.$i18n_t(`accMgmt.tenant.integrations.iec104.iec104ExtraInfo`)) + "\n          ")]) : _vm._e()])], 1), integration.id && integration.type === 'influxdb' ? _c(VCol, {
      staticClass: "py-0 my-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('pre', {
      staticClass: "custom_bottom_margin"
    }, [_vm._v("  DB: \"" + _vm._s(_vm.get(integration, 'options.influxDB.dbname')) + "\"\n  User: \"" + _vm._s(_vm.get(integration, 'options.influxDB.user')) + "\"\n  Password: \"" + _vm._s(_vm.get(integration, 'options.influxDB.password')) + "\"\n        ")])]) : _vm._e(), integration.id && integration.type === 'grafana' ? _c(VCol, {
      staticClass: "py-0 my-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('pre', {
      staticClass: "custom_bottom_margin"
    }, [_vm._v("  URL: \"" + _vm._s(_vm.get(integration, 'options.grafana.url')) + "\"\n        ")])]) : _vm._e(), integration.isEnabled ? _c(VCol, {
      staticClass: "py-0 my-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('pre', [_vm._v("  " + _vm._s(_vm.$i18n_t(`accMgmt.tenant.integrations.activatedSince`)) + " " + _vm._s(_vm.localizeDate(_vm.get(integration, `options.${integration}.activatedSince`) || _vm.get(integration, 'createdAt'))) + "\n        ")])]) : _vm._e()], 1);
  }), 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };